import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { Modal } from "antd";
import { svg } from "../../../Assets/svg";
import { BtnLoader } from "../../../Components/Components";

const CommonDeleteModal: React.FC<{
  visible: boolean;
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  handleDelete: any;
  title: string;
  description: string | React.ReactNode;
  isLoading: boolean;
  setIsDeleteId?: React.Dispatch<React.SetStateAction<any>>;
  buttonName?: string;
  isLogo?: boolean;
  setAdditionalId?: React.Dispatch<React.SetStateAction<any>>;
  iconSvg?: JSX.Element;
  isSuccess?: boolean;
  isNonDelete?: boolean;
  isFlexColumn?: boolean;
  descriptionClassName?: string;
  children?: React.ReactNode;
  zIndex?: number;
}> = ({
  visible,
  setIsModalVisible,
  handleDelete,
  title,
  description,
  setIsDeleteId,
  isLoading,
  buttonName,
  isSuccess = false,
  isNonDelete = false,
  isFlexColumn = false,
  descriptionClassName = "",
  children,
  zIndex,
}) => {
    const onClose = () => {
      setIsModalVisible(false);
      if (setIsDeleteId) {
        setIsDeleteId(null);
      }
    };
    return (
      <Modal
        title={""}
        visible={visible}
        onCancel={onClose}
        width={"32.813rem"}
        closeIcon={svg.closeIcon}
        centered
        zIndex={zIndex}
        footer={
          <div className="d-flex justify-content-center gap-4">
            <button
              type="button"
              className="btn btn-lg btn-outline-secondary min-w-130"
              onClick={onClose}
            >
              CANCEL
            </button>
            <button
              type="button"
              disabled={isLoading}
              className={`btn btn-lg min-w-130 ${!!isNonDelete
                ? "btn-primary"
                : isSuccess
                  ? "btn-success"
                  : "btn-danger"
                }`}
              onClick={handleDelete}
            >
              {isLoading ? <BtnLoader /> : buttonName ? buttonName : "DELETE"}
            </button>
          </div>
        }
        className="delete-modal"
      >
        <div className="modal-body page-form">
          {/* <div className="d-flex justify-content-center">{svg?.actionDelete}</div> */}
          <div className="fw-bold fs-4 d-flex text-black justify-content-center text-center">
            {title}
          </div>
          <div
            className={`fs-6 d-flex justify-content-center mt-3 text-center text-4a4a4a ${isFlexColumn ? "flex-column" : ""
              } ${descriptionClassName}`.trim()}
          >
            {description}
          </div>
          {children}
        </div>
      </Modal>
    );
  };

export default CommonDeleteModal;
